import { DraftConfiguration, View } from '@/types';
import { getConfigurationsOnView } from './getConfigurationsOnView';
import { getSortedConfigurations } from './getSortedConfigurations';

export const getSortedConfigurationsOnView = (
  configurations: DraftConfiguration[],
  configurationIds: number[],
  view: View
) => getSortedConfigurations(getConfigurationsOnView(configurations, view), configurationIds);
